<template>
  <div
    class="relative max-w-xs overflow-hidden rounded-lg ring-1 ring-gray-300 transform transition duration-500 hover:scale-100 shadow-all"
  >
    <img
      class="object-cover w-full h-68"
      :src="data && thumbnailUrl(data.thumbnail_url)"
      alt="..."
      @error="defaultImage"
    />
    <div class="absolute top-0 left-0 px-6 py-4 text-white">
      <h4 class="text-2xl font-semibold tracking-tight">
        {{ data && data.name }}
      </h4>
      <p class="leading-normal text-xs">Over 2,564 Students</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryCard",
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      url: window.config.VUE_APP_BASE_URL,
    };
  },
  methods: {
    thumbnailUrl(str) {
      if (str === null) {
        return null;
      } else {
        return this.url + str;
      }
    },
  },
};
</script>